import React, {
  JSXElementConstructor, ReactElement, ReactNode
} from 'react'
import { IconButton } from '@mui/material'
import ButtonMenu from '../buttonMenu/ButtonMenu'
import MoreVertIcon from '@mui/icons-material/MoreVert'

interface Props {
  children: (ReactElement<any, string | JSXElementConstructor<any>> | ReactElement<any, string | JSXElementConstructor<any>>[]) & ReactNode
}

const ThreeDotMenu:ReactFC<Props> = ({ children }) => {
  return (
    <ButtonMenu
      button={(
        <IconButton
          sx={{
            color: 'primary.main'
          }}
        >
          <MoreVertIcon />
        </IconButton>
      )}
    >
      {
        children
      }
    </ButtonMenu>
  )
}
export default ThreeDotMenu
